import { Injectable } from '@angular/core';
import { AvisConcerneService } from '../avisConcerne/avis-concerne.service';
import { DelaisService } from '../delai/delais.service';
import { DescriptionService } from '../description/description.service';
import { LotsService } from '../lots/lots.service';
import { RensCompltService } from '../rensCompl/rens-complt.service';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';

@Injectable({
  providedIn: 'root'
})
export class DiversInitialService {

  constructor(public avisConcerneService: AvisConcerneService, public delaiService: DelaisService, public descriptionService: DescriptionService,
              public lotsService: LotsService, public rensComplService: RensCompltService,
              public formExtractorService: FormExtractorService) {
  }
}
